// StaffAndPlantWrapper.js (updated to use new staff structure)
import React, { useState, useEffect } from "react";
import { useAtom } from "jotai";
import StaffAndPlantComponent from "./staffandplantcomponent";
import { staffAtom, fetchProjectStaffAtom, fetchOrgStaffAtom } from "../../atoms/staff_and_plant/satffAtom"; 
import { plantAtom, fetchProjectPlantsAtom, fetchOrgPlantsAtom } from "../../atoms/staff_and_plant/plantAtom";
import settingsAtom from "../../atoms/settings/SettingsAtom";

const StaffAndPlantWrapper = ({ activeComponent = "both" }) => {
  const [staffData] = useAtom(staffAtom);
  const [plantData] = useAtom(plantAtom);
  const [settings] = useAtom(settingsAtom);
  const [, fetchProjectStaff] = useAtom(fetchProjectStaffAtom);
  const [, fetchOrgStaff] = useAtom(fetchOrgStaffAtom);
  const [, fetchProjectPlants] = useAtom(fetchProjectPlantsAtom);
  const [, fetchOrgPlants] = useAtom(fetchOrgPlantsAtom);

  const [loader, setLoader] = useState(false);
  const [selectType, setSelectType] = useState(null); 
  const [selectItem, setSelectItem] = useState(null);
  const [isSelect, setIsSelect] = useState(false);

  const data = {
    staffData: staffData?.projectStaff || [],
    plantData: plantData?.projectPlants || [],
    projectList: settings?.projectList || [],
    currentProject: settings?.currentProject || null,
  };

  useEffect(() => {
    const loadData = async () => {
      setLoader(true);
      try {
        const active = activeComponent?.toLowerCase();
        const fetchPromises = [];

        if (active === "both" || active === "staff" || active === "stafflist") {
          if (!staffData.projectStaff.length) {
            fetchPromises.push(fetchProjectStaff());
          }
          if (!staffData.orgStaff.length) {
            fetchPromises.push(fetchOrgStaff());
          }
        }

        if (active === "both" || active === "plant" || active === "plantlist") {
          if (!plantData.projectPlants.length) {
            fetchPromises.push(fetchProjectPlants());
          }
          if (!plantData.orgPlants.length) {
            fetchPromises.push(fetchOrgPlants());
          }
        }

        await Promise.all(fetchPromises);
      } catch (error) {
        console.error("Error loading data:", error);
      } finally {
        setLoader(false);
      }
    };

    loadData();
     // eslint-disable-next-line
  }, [activeComponent, fetchProjectStaff, fetchOrgStaff, fetchProjectPlants, fetchOrgPlants]);

  const props = {
    data,
    loader,
    active: activeComponent,
    selectType,
    selectItem,
    setSelectType,
    setSelectItem,
    isSelect,
    setIsSelect,
  };

  return <StaffAndPlantComponent {...props} />;
};

export default StaffAndPlantWrapper;